import NotifIcon from "./NotifIcon";

export default NotifIcon;
